import React from 'react';
import { JSX } from 'react/jsx-runtime';

const BusIconsDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.99994 4L1 4.99997"
        stroke="#EEF7FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 4H12.9999"
        stroke="#EEF7FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.9999 4.99997L19 4"
        stroke="#EEF7FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.9996 1H4.99994C3.8954 1 3 1.8954 3 2.99994V14.9996C3 16.1041 3.8954 16.9995 4.99994 16.9995H16.9996C18.1041 16.9995 18.9995 16.1041 18.9995 14.9996V2.99994C18.9995 1.8954 18.1041 1 16.9996 1Z"
        stroke="#EEF7FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 9H18.9995"
        stroke="#EEF7FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 12.9961H7.01096"
        stroke="#EEF7FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 12.9961H15.011"
        stroke="#EEF7FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 17V18.9999"
        stroke="#EEF7FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 18.9999V17"
        stroke="#EEF7FF"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BusIconsDark;
